import EFOcats_answer from './efocats_answer.js';
import EFOcats_import_html from '../import/efocats_import_html.js';

/**
 * typeLabel[j] === "radio"の時の回答欄設置処理
 */
export default class EFOcats_answer_radio extends EFOcats_answer {
  /**
   * 回答欄設置
   */
  set(tmp, answer, elem) {
    elem.find('.inner').addClass('radio_block check-flag message-flag');

    // 画像選択の判断
    if (typeof answer.value[0] === 'object' && answer.value[0].img) {
      elem.find('.container').addClass('img_select');
      // 画像選択の場合
      for (let h = 0; h < answer.value.length; h++) {
        const input = elem.find('.check-flag').append(
          EFOcats_import_html.getValue('img_question', {
            val: answer.value[h].val,
            name: answer.name,
            img: answer.value[h].img,
            text: answer.value[h].text,
          })
        );

        this.attr(input.children('input').get(0), answer, elem);
      }
    } else {
      // テキストデータの場合
      for (let h = 0; h < answer.value.length; h++) {
        const input = elem.find('.check-flag').append(
          EFOcats_import_html.getValue('text_question', {
            name: answer.name,
            val: Object.keys(answer.value[h])[0],
            text: Object.values(answer.value[h])[0],
          })
        );

        this.attr(input.find('input').last().get(0), answer, elem);
      }
    }
  }
}
